import React from 'react'

import { IconProps, ICON_SIZES_MAPPING_TO_PX } from './Icon.model'

import { BaseIcon } from './BaseIcon'

export const Icon = React.forwardRef<SVGSVGElement, IconProps>(({ size, ...props }, ref) => (
  <BaseIcon ref={ref} {...props} sizeInPx={ICON_SIZES_MAPPING_TO_PX[size]} />
))
